import React, { useState } from 'react'
import InputCustom from '../../../../components/elements/InputCustom'
import '../zones/Zone.css'
import { AbstructVar } from '../../../../components/general/general-component/abstruct-component/AbstructVar';
import { postZoneType } from '../../../../store/Actions/ActionZoneType';
import ReactLoading from "react-loading";

function AddZoneType({ warehouse_id,translate }) {
    const { dispatch } = AbstructVar();
    const [zone_type, setzone_type] = useState('')
    const [symbol, setsymbol] = useState('')
    const [load, setLoad] = useState('')
    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(postZoneType(zone_type, symbol, warehouse_id, 'd', setLoad));
    };
    return (
        <div className='d-flex' style={{ marginTop: "10px", alignItems: "center" }} >
            <InputCustom
                label='zone_type'
                iconType='pencil'
                type='text'
                value1={zone_type}
                onChange={(e) => setzone_type(e.target.value)}
            />
            <InputCustom
                label='symbol'
                iconType='pencil'
                type='text'
                value1={symbol}
                onChange={(e) => setsymbol(e.target.value)}
            />
            <div className='plus_zone_typ' onClick={handleSubmit} >
                {
                    load ? <ReactLoading
                        type="spin"
                        color="black"
                        height={"40%"}
                        width={"40%"}
                    /> : <i className='fa fa-plus' ></i>
                }

            </div>
        </div>
    )
}

export default AddZoneType